import React, { useEffect } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import HeroSection from "../../../layout/HeroSection";
import { pageRoutes } from "../../../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import { fetchGlossaryTerms } from "../../../redux/action/moreAction";
import Loader from "../../../components/other/Loader";

const GlossaryOfTerms = () => {
  const dispatch = useDispatch();
  const { glossaryterms, isLoading } = useSelector(
    (state) => state?.moreReducer
  );

  useEffect(() => {
    dispatch(fetchGlossaryTerms());
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <div>
        <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Terms and Conditions"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "Terms and Conditions",
              path: `${pageRoutes?.home}/`,
            },
          ]}
        />

        <div class="untree_co-section">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <h2 class="section-title text-center pb-5">
                  <strong>{glossaryterms?.glossary_term_title ?? ""}</strong>
                </h2>
              </div>
            </div>
            <div class="row">
              <div class="ct_team_info1">
                <div
                  dangerouslySetInnerHTML={{
                    __html: `${glossaryterms?.glossary_term_description}`,
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default GlossaryOfTerms;
